import { useTranslation } from 'react-i18next';

import i18nUI from 'src/translation/i18nUI';

import { I18NextNS } from 'src/models/Language.model';

const useUiTranslation = () => {
  const {
    t: tCommon,
    i18n: { language, changeLanguage },
  } = useTranslation(I18NextNS.TRANSLATION, {
    i18n: i18nUI,
    keyPrefix: 'ui.common',
  });
  const { t: tPages } = useTranslation(I18NextNS.TRANSLATION, {
    i18n: i18nUI,
    keyPrefix: 'ui.pages',
  });

  return { tCommon, tPages, language, changeLanguage };
};

export default useUiTranslation;
